module.exports = __webpack_public_path__ + "img/pipe3.fe2095db.png";